import type { SVGProps } from "react";
import type { FC } from 'react';
import styled from 'styled-components';
import { iconSizeMap } from '../utils/size-map';
import type { IconSize, TokenSizeProps } from '../utils/type';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<TokenSizeProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.707 4.293a1 1 0 0 1 0 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0" clipRule="evenodd" /></svg>;
const Wrapper = styled.span<{
  $size?: IconSize;
}>`
  width: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  height: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  display: inline-block;
  vertical-align: middle;
`;
const SvgArrowLeft = ({
  $size,
  ...rest
}: TokenSizeProps) => <Wrapper $size={$size} className="mnd-icon"><SvgBase {...rest} /></Wrapper>;
export default SvgArrowLeft;